import RendermixAPI from "./rendermix-api";
import StoresAPI from "./stores-api";
import PaymentsAPI from "./payments-api";
import KycAPI from "./kyc-api";
import { analytics } from "../services/analytics";

export const rendermixAPI = new RendermixAPI();
export const storesAPI = new StoresAPI();
export const paymentsAPI = new PaymentsAPI();
export const kycAPI = new KycAPI();

// api_error observation (WEB-4044): 5xx/timeouts on any API surface as
// analytics events; failures still propagate to callers unchanged.
analytics.attachApiErrorTracking((rendermixAPI as any).client, "rendermix");
analytics.attachApiErrorTracking((storesAPI as any).client, "stores");
analytics.attachApiErrorTracking((paymentsAPI as any).client, "payments");
analytics.attachApiErrorTracking((kycAPI as any).client, "kyc");
